<template>
  <v-menu
    id="org-menu"
    v-model="open"
    offset-y
    bottom
    tile
    left
    content-class="org-menu-content"
    :attach="attach"
    max-height="350px"
  >
    <template #activator="{on, attrs}">
      <div
        v-bind="attrs"
        :class="['org-menu-activator', {open: open }]"
        v-on="on"
      >
        <div class="org-menu-activator__content">
          All organizations
          <v-icon
            color="white"
            size="14"
          >
            {{ open ? '$faChevronUp' : '$faChevronDown' }}
          </v-icon>
        </div>
      </div>
    </template>
    <div class="org-menu-dropdown">
      <div class="org-menu-header">
        <div class="org-menu-header__content">
          Select an Organization
        </div>
      </div>
      <org-list />
    </div>
  </v-menu>
</template>

<script>
  import OrgList from './OrgList'

  export default {
    name: 'MultiOrgMenu',
    components: { OrgList },
    props: { attach: String },
    data () {
      return {
        open: false,
      }
    },
  }
</script>

<style lang="scss">
@mixin white-lato {
  font-family: 'Lato', sans-serif;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
}
  .org-menu-activator, .org-menu-activator.open {
    display: flex;
    height: 83px;
    background-color: #395453;
    border-bottom: 1px solid $accent;
    width:100%;
    & > .org-menu-activator__content {
      margin: auto 0 auto 25px;
      @include white-lato();
      font-size: 13px;
      letter-spacing: 1px;
    }
  }
  .org-menu-activator.open {
      background-color: $primary;
      border-bottom: 1px solid #34455f;
    }
  .org-menu-content {
    box-shadow: unset;
  }
  .org-menu-dropdown {
    padding: 0 25px;
    background-color: $primary;
    min-height: 140px;
    & > .org-menu-header {
      height: 48px;
      display: flex;
      & > .org-menu-header__content {
        @include white-lato();
        margin: 21px 0 15px 0;
        letter-spacing: 1.5px;
        font-size: 10px;
      }
    }
}

</style>
